import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row } from "reactstrap";
import { decreaseQuantity, increaseQuantity } from "store/actions/cartAction";
import { FaMinus, FaPlus } from "react-icons/fa";

const ItemCounter = ({
  selectedItem,
  setSelectedItemsSize,
  bgColor,
  cartItem, //To handle if cart item is passed
}) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(1);

  const increment = () => {
    const newQuantity = value + 1;
    setValue(newQuantity);
    setSelectedItemsSize(newQuantity);
  };

  const decrement = () => {
    if (value > 1) {
      const newQuantity = value - 1;
      setValue(newQuantity);
      setSelectedItemsSize(newQuantity);
    }
  };

  useEffect(() => {
    if (selectedItem?.quantity === 0) {
      setSelectedItemsSize(1);
      setValue(1);
    }
  }, [selectedItem, setSelectedItemsSize]);

  return (
    <Row className="mb-2 mt-4 mx-1">
      <div
        onClick={() => {
          const quantity =
            selectedItem?.type === "cart" ? cartItem.quantity : selectedItem?.quantity || 1;
          if (quantity > 1) {
            selectedItem?.type === "cart"
              ? dispatch(decreaseQuantity(cartItem))
              : decrement();
          }
        }}
        style={{
          pointerEvents:
            (selectedItem?.type === "cart"
              ? cartItem.quantity
              : selectedItem?.quantity || 1) <= 1   
              ? "none"
              : "auto",
        }}
        className="top_cards__operators d-flex justify-content-center align-items-center"
      >
        <FaMinus />
      </div>
      <div className="top_cards__number">
        {selectedItem?.type === "cart" ? cartItem.quantity : selectedItem?.quantity || 1}
      </div>
      <div
        onClick={() => {
          selectedItem?.type === "cart" ? dispatch(increaseQuantity(cartItem)) : increment();
        }}
        style={{ border: `2px solid ${bgColor}`, color: bgColor }}
        className="top_cards__operators-active d-flex justify-content-center align-items-center"
      >
        <FaPlus />
      </div>
    </Row>
  );
};

export default ItemCounter;
